// extracted by mini-css-extract-plugin
export default {"tooltip":"cQ-z","arrow":"dQ-z"};